import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import { SOUNDPROOFING_LAYER_SIZES, SOUNDPROOFING_LAYER_TYPES } from '../../../../constants/soundproofing';
import TickIcon from '../../../../assets/icons/whiteSmallTick.svg';
import CrossIcon from '../../../../assets/icons/crossExtraSmall.svg';
import PenBlueIcon from '../../../../assets/icons/penBigBlue.svg';
import PenGrayIcon from '../../../../assets/icons/penBigGray.svg';

function SchemeLayer({
  type,
  label,
  isSelected,
  isInactive,
  isFilled,
  isRemovable,
  onClick,
  onRemoveClick,
}) {
  const isGlass = type === SOUNDPROOFING_LAYER_TYPES.glass;
  const { width, height } = SOUNDPROOFING_LAYER_SIZES[type];
  const scale = isInactive ? SOUNDPROOFING_LAYER_SIZES.inactiveScale : 1;

  return (
    <div className={classNames(styles.column, { [styles.columnInactive]: isInactive })}>
      <div className={styles.removeSlot}>
        {isRemovable && (
          <div className={classNames(styles.remove, 'pressable')} onClick={onRemoveClick}>
            <img src={CrossIcon} alt="X" />
          </div>
        )}
      </div>

      <div className={styles.bodySlot} style={{ height: `${height}px` }}>
        <div
          className={classNames(styles.body, isGlass ? styles.glass : styles.frame, {
            [styles.bodySelected]: isSelected,
          })}
          style={{ width: `${width * scale}px`, height: `${height * scale}px` }}
          onClick={onClick}
        >
          {!isGlass && <div className={styles.frameTop} />}
          {!isGlass && <div className={styles.frameBottom} />}

          <div className={classNames(styles.indicator, { [styles.indicatorFilled]: isFilled })}>
            {isFilled && <img src={TickIcon} alt="V" />}
          </div>

          {!isSelected && (
            <img src={isGlass ? PenBlueIcon : PenGrayIcon} alt="Edit" className={styles.pen} />
          )}
        </div>
      </div>

      <p className={styles.label}>{label}</p>
    </div>
  );
}

export default SchemeLayer;
